<template>
  <div>
    <label class="titlePage">Alterações - Colégios</label>

    <fccTable
      striped
      hover
      responsive
      search
      pagination
      :fields="fields"
      :items="tratamentoColegios"
      :porPage="itemsPorPage"
    >
    </fccTable>
  </div>
</template>
<script>
import store from '../../../../../store'

export default {
  props: ['tratamentoColegios'],
  data() {
    return {
      dadosSelecionados: [],
      fields: [
        { key: 'cidade', label: 'Cidade', sortable: true },
        { key: 'colegio', label: 'Colégio', sortable: true },
        { key: 'tecnico', label: 'Tecnico', sortable: true },
        { key: 'tratamento', label: 'Tratamento', sortable: true },
        { key: 'dataatualizacao', label: 'Data Atualização', sortable: true }
      ],
      itemsPorPage: 10
    }
  },
  computed: {
    configuracao() {
      return store.state.localDeProva.configuracao
    }
  }
}
</script>